import React, { Component } from 'react';
import { getApiHeader, removeUserSession } from '../../../utils/CommonFunctions';
import axios from 'axios';
import swal from 'sweetalert';
import PageLoader from '../../Loader/loader';
import PlanTabs from './PlanList/PlanTab';
import Plan from './PlanList/Plan';


const SERVER_URL = process.env.REACT_APP_SERVER_URL;


class PostPaidAddPacks extends Component {

    state = {
        loading: false,
        plans: [],
        nbn_api_log_id: '',
        plan_details: [],
        model_visibility: false,
        // select_plan_id: '',
        response_message:'',
        selected_number: "",
        customer_activations:[],
        reference_number: '',
        reference_number_applied:false,
        reference_number_plan:null,
        is_sim_credit_plan:false,
        seletedPlanId:null,
        reference_number: '',
        reference_number_applied: false,
        reference_number_plan: null,
        is_sim_credit_plan:false,
        newPlansId:"",
        selected_mobile_number:"",
        

    }

    componentDidMount() {
         this.getActivations();
    }

      getActivations = async () => {
        let headers = await getApiHeader();
        this.setState({ loading: true });
        let res = await axios.get(`${SERVER_URL}postpaid/user_activations`, { headers }).then(async response => {

            let data = response.data.data.list;
            let selected_number = '';
            let mobile = '';
            const { location } = this.props;

            this.setState({ loading: false});
            if (data.length > 0) {

              
                    selected_number = data[0].activation_id;
                    mobile = data[0].mobile_number
            } else {

                selected_number = null;
                mobile = null;
            }
       
            sessionStorage.setItem('selected_number', selected_number);
               
            this.setState({
                selected_number: selected_number,
            });


            let mobileNumber = sessionStorage.getItem("postpaidselectedNum");

            if (mobileNumber) {
              const index = data.findIndex(item => item.mobile_number === mobileNumber);
            
              if (index !== -1) {
                // Take out the matched item
                const [matched] = data.splice(index, 1);
                // Put it at the front
                data.unshift(matched);
              }

              
            
              this.setState({ customer_activations: data });
            } else {
              this.setState({ customer_activations: data });
            }
            
            
            







           
            
            
            //  this.setState({ customer_activations: data });
             this.setState({ loading: false });

        }).catch(error => {
                swal("Internal Server Error", "", "warning");
                this.setState({ loading: false});
        });

    };

    handleClose = () => this.setState({ model_visibility: false });


    getDefaultPlans = async (selected_number) => {

        this.setState({ loading: true });
        let headers = await getApiHeader();
        const post_data = {
            // post_paid_activation_id: sessionStorage.getItem('postpaid_activation_id')
            post_paid_activation_id: selected_number
        };
        let res = await axios.post(`${SERVER_URL}postpaid/pst-ad-pac`, post_data, { headers }).then(response => {
           
            let data = response.data.data;
            this.setState({ plans: data.plans })
            this.setState({ loading: false, plans: data.plans, nbn_api_log_id: data.nbn_api_log_id });

        }).catch(error => {

            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }

    PlanSelectHandler = async (plan_id) => {
       
        
        this.setState({ loading: true });
        let headers = await getApiHeader();
        let post_paid_activation_id = this.state.selected_number;
        
        const post_data = {
            post_paid_plan_id: plan_id,
            post_paid_activation_id:post_paid_activation_id
            // nbn_api_log_id: this.state.nbn_api_log_id
        };
        let res = await axios.post(`${SERVER_URL}postpaid/pst-ad-pac_dtls`, post_data, { headers }).then(response => {
            if (response.data.data.customMessage) {
                if (response.data.data.customMessage !== 'undefined') {
                    this.setState({ customMesssge: response.data.data.customMessage });
                }
            }
            let data = response.data.data;
            console.log(data);
            this.setState({response_message :response.data.message})
            this.setState({ plan_details: data })
            this.setState({ loading: false, select_plan_id: plan_id });
                swal({
                    text: response.data.message,
                    icon: "warning",
                    dangerMode: true,
                    buttons: {
                        confirm: { text: 'Confirm', className: 'sweet-warning' },
                        cancel: 'No, Cancel'
                    }
                })
                .then((confirmed) => {
                    if (confirmed) {
                        this.ChangePlanSubmitHandler(plan_id,data.session_id);
                    }
                });
            
            
        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }


    ChangePlanSubmitHandler = async (plan_id,sessionid) => {

        this.setState({ loading: true, model_visibility: false });
        let headers = await getApiHeader();
        let post_paid_activation_id = this.state.selected_number;
        
        const post_data = {
            post_paid_plan_id: plan_id,
            post_paid_activation_id:post_paid_activation_id,
            session_id:sessionid,
            // nbn_api_log_id: this.state.nbn_api_log_id
        };
        let res = await axios.post(`${SERVER_URL}postpaid/cfrm-pst-ad-pac`, post_data, { headers }).then(response => {
             const responseData = response.data;

            // Optional: Check if responseData.data is an object
            if (typeof responseData.data === 'object' && responseData.data !== null) {
                if (responseData.data.customMessage && responseData.data.customMessage !== 'undefined') {
                    this.setState({ customMesssge: responseData.data.customMessage });
                }
            }

            this.setState({ loading: false });

            if (response.status === 200) {
                swal('Success', responseData.message || 'Recharge successful')
                    .then(() => {
                        // This runs after the alert is closed
                        window.location.reload();
                    });
            }
        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }

    setSelectedPlan = async (plan_id, reference_number_applied, plan, reference_number, is_sim_credit_plan)=>{
        console.log(plan_id)
        this.setState({seletedPlanId: plan_id, reference_number_applied:reference_number_applied, reference_number_plan:plan, reference_number:reference_number, is_sim_credit_plan:is_sim_credit_plan},()=>{

            if(reference_number_applied === true)
            {
                this.setState({reference_number_plan:plan});
            }

        });

    }

    goNextStep = (plan)=>{

         console.log('plan-=========>',plan);
        
        let plan_id = plan.plan_id;
        let plan_added = true;
        if(this.state.seletedPlanId == null)
        {
            plan_added = false;
        }
        
       
        this.PlanSelectHandler(plan);
        // return;
        
    }

    handleNumberChange = (event) => {

        
       
        const selectedNumber = event.target.value;
        this.setState({ selected_number: selectedNumber });
        // sessionStorage.setItem('postpaid_activation_id',selectedNumber)
         this.setState({newPlansId:selectedNumber})
        //  sessionStorage.removeItem("postpaidselectedNum");
       
       
    };

    render() {
     








        return (
            <>
                {this.state.loading === true ? <PageLoader /> : null}
                <div className="container" id="nbn-planSelectionBox">
                    

                    <section className="nbn-common-section">
                         <div className="row">
                            <div className="col-lg-10 col-xl-10 order-lg-1 order-xl-1">
                            </div>
                            <div className="col-lg-2 col-xl-2 order-lg-2 order-xl-2">
                                <div className="form-group row"  style={{ display: "flex", marginLeft: "auto", justifyContent: "flex-end" ,marginTop:"10px"}}>
                                    <div className="col-lg-10 col-md-12 col-sm-12 number-select custom-select num-picker">
                                        <select
                                            className="form-select"
                                            onChange={this.handleNumberChange}
                                            name="activation"
                                        >
                                            {this.state.customer_activations.filter((activation) => activation.is_wme_prepaid === 0).map(person => (
                                                <option
                                                    key={person.activation_id}
                                                    value={person.activation_id}
                                                >
                                                    {person.mobile_number}
                                                </option>
                                            ))}
                                        </select>


                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="row">
                            <div className="nbn-header-title">
                                <h2 className="nbn-h3"> Choose your add-on packs for SIM Only Plans </h2>
                                <p style={{ textAlign: "left" }}>Discover the best SIM Only packs from Telsim that can be designed to your needs at different speeds.</p>
                            </div>


                            <PlanTabs setSelectedPlan={this.setSelectedPlan} activeSection="28-day_plan" from="add-packs" goNextStep={this.goNextStep}  newPlan={this.state.newPlansId} />
                            {/* : <Plan plan_reference_number={this.state.reference_number} referenceNumberApplied={true} plan={this.state.reference_number_plan} selectedPlan={this.state.reference_number_plan} /> */}




                        </div>
                    </section>
                    <br />
                </div>
            </>
        );
    }

}

export default PostPaidAddPacks;

